/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AtoNDefinitionScheduleInner
 */
export interface AtoNDefinitionScheduleInner {
    /**
     * Start time of schedule
     * @type {string}
     * @memberof AtoNDefinitionScheduleInner
     */
    start?: string;
    /**
     * End time of schedule
     * @type {string}
     * @memberof AtoNDefinitionScheduleInner
     */
    end?: string;
}

/**
 * Check if a given object implements the AtoNDefinitionScheduleInner interface.
 */
export function instanceOfAtoNDefinitionScheduleInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNDefinitionScheduleInnerFromJSON(json: any): AtoNDefinitionScheduleInner {
    return AtoNDefinitionScheduleInnerFromJSONTyped(json, false);
}

export function AtoNDefinitionScheduleInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoNDefinitionScheduleInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
    };
}

export function AtoNDefinitionScheduleInnerToJSON(value?: AtoNDefinitionScheduleInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'end': value.end,
    };
}

